module.exports = __webpack_public_path__ + "static/media/home-outline.e6cef25a.svg";